document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-item').forEach(productCard => {

    // Full price container (not just span)
    const priceContainer = productCard.querySelector('[data-dynamic-price]');
    if (!priceContainer) return;

    const variantRadios = productCard.querySelectorAll('.variant-radio-input');

    // Format cents to money
    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    // Update price + discount cut
    function updatePrice(priceCents, compareCents = null) {
      let html = `<span class="price"><span>${formatMoney(priceCents)}</span></span>`;

      if (compareCents && compareCents > priceCents) {
        html += `<span class="price-compare">${formatMoney(compareCents)}</span>`;
      }

      priceContainer.innerHTML = html;
    }

    // Variant change
    variantRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;

        const price = parseInt(radio.getAttribute('data-variant-price'));
        const compare = parseInt(radio.getAttribute('data-variant-compare')) || null;

        updatePrice(price, compare);
      });
    });

    // Initial load
    const checkedRadio = productCard.querySelector('.variant-radio-input:checked');
    if (checkedRadio) {
      const price = parseInt(checkedRadio.getAttribute('data-variant-price'));
      const compare = parseInt(checkedRadio.getAttribute('data-variant-compare')) || null;

      updatePrice(price, compare);
    }

  });
});
